var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "model" }, [
      _c("div", { staticClass: "area df hao jcb" }, [
        _c(
          "div",
          {
            staticClass: "name",
            style: { fontSize: _vm.name.length > 7 ? "0.18rem" : "0.3rem" }
          },
          [_vm._v(_vm._s(_vm.replace(_vm.name)))]
        ),
        _vm._v(" "),
        _vm.$h5Power != "guest" || _vm.mid == 14 || _vm.mid == 15
          ? _c("div", { staticClass: "ask", on: { click: _vm.toRelease } }, [
              _vm._v("提问")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search df hao" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword"
            }
          ],
          staticClass: "flex",
          attrs: { type: "text", puc: "", placeholder: "本版块搜索" },
          domProps: { value: _vm.keyword },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.keyword = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "btn", on: { click: _vm.search } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "scroll", on: { scroll: _vm.listenScroll } }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function(v, i) {
            return _c(
              "div",
              {
                staticClass: "li",
                on: {
                  click: function($event) {
                    return _vm.toDetail(v)
                  }
                }
              },
              [
                _c("div", { staticClass: "title" }, [
                  v.announcement == 1
                    ? _c("i", { staticClass: "rule" })
                    : _vm._e(),
                  v.refining == 1
                    ? _c("i", { staticClass: "prize" })
                    : _vm._e(),
                  v.top == 1 ? _c("i", { staticClass: "top" }) : _vm._e(),
                  _c("div", { domProps: { innerHTML: _vm._s(v.title) } }, [
                    _vm._v(_vm._s(v.title))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tool df" }, [
                  _c("div", { staticClass: "flex" }, [
                    _vm._v(
                      _vm._s(
                        v.answerTotal > 0
                          ? v.answerTotal + "人回答"
                          : "暂无回答"
                      ) +
                        " · " +
                        _vm._s(
                          v.attentionTotal > 0
                            ? v.attentionTotal + "人关注"
                            : "暂无关注"
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v(_vm._s(v.creatorName || ""))]),
                    _vm._v(_vm._s(_vm.dateTime(v.createTime)))
                  ])
                ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6237444d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6237444d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/topic/list/list.vue
// module id = null
// module chunks = 